<ng-container *ngIf="enabled">
    <!-- Floating Action Button -->
    <button class="support-fab" (click)="toggle()" [class.active]="view !== 'closed'" aria-label="Support">
        <span class="support-fab-icon" *ngIf="view === 'closed'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
        </span>
        <span class="support-fab-icon" *ngIf="view !== 'closed'">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        </span>
        <span class="support-fab-badge" *ngIf="view === 'closed' && unreadCount > 0">
            {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
    </button>

    <!-- Panel -->
    <div class="support-panel" [class.open]="view !== 'closed'" [class.wide]="view === 'chat'">
        <!-- Header -->
        <div class="support-panel-header">
            <button *ngIf="view === 'new' || view === 'detail'" class="support-back-btn" (click)="showList()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6" />
                </svg>
            </button>
            <div class="support-panel-title">
                <!-- Support/Assistant tab switcher, only when the assistant is enabled and the user is a manager+ -->
                <div class="support-tabs" *ngIf="(view === 'list' || view === 'chat') && assistantService.isEnabled && userService.isGranted('ROLE_MANAGER'); else plainTitle">
                    <button class="support-tab" [class.active]="view === 'list'" (click)="showList()">Support</button>
                    <button class="support-tab" [class.active]="view === 'chat'" (click)="showChat()">Assistant</button>
                </div>
                <ng-template #plainTitle>
                    <span *ngIf="view === 'list'">Support</span>
                    <span *ngIf="view === 'chat'">Assistant</span>
                    <span *ngIf="view === 'new'">New Request</span>
                    <span *ngIf="view === 'detail'">{{ selectedTicketKey }}</span>
                </ng-template>
            </div>
            <button class="support-close-btn" (click)="close()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>

        <!-- Body -->
        <div class="support-panel-body">
            <!-- Admin: not connected (executives only) -->
            <div *ngIf="isAdmin && connected === false && view === 'list'" class="support-connect">
                <div class="support-connect-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                    </svg>
                </div>
                <p class="support-connect-title">Connect to Jira Service Desk</p>
                <p class="support-connect-sub">Jira API credentials are not configured. Set the following environment variables:</p>
                <code class="support-connect-url">JIRA_API_EMAIL<br>JIRA_API_TOKEN<br>JIRA_BASE_URL<br>JIRA_ORG_ID<br>JIRA_ORG_NAME</code>
            </div>

            <!-- Normal ticket views (shown when connected or for non-admin users) -->
            <ng-container *ngIf="!isAdmin || connected !== false">
                <app-support-ticket-list *ngIf="view === 'list'" [pendingTicket]="pendingTicket"
                    (selectTicket)="showDetail($event)" (newTicket)="showNewTicket()">
                </app-support-ticket-list>

                <app-support-ticket-form *ngIf="view === 'new'" (ticketCreated)="onTicketCreated($event)"
                    (cancel)="showList()">
                </app-support-ticket-form>

                <app-support-ticket-detail *ngIf="view === 'detail'" [issueKey]="selectedTicketKey"
                    (confirmed)="onTicketConfirmed()">
                </app-support-ticket-detail>
            </ng-container>

            <!-- AI assistant: independent of the Jira connection (it doesn't use Jira) -->
            <app-support-assistant *ngIf="view === 'chat'"></app-support-assistant>
        </div>
    </div>
</ng-container>
